import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class ProvinceResolver implements Resolve<string> {

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): string {
    return rstate.root.firstChild.url[0].path.toLowerCase();
  }
}
